<template>
	<HeadlinedTitleList
		v-if="!isEmpty"
		:titles="similarTitles"
		:title="title"
		:sponsoredAd="sponsoredAd"
		:additionalContexts="additionalContexts"
		:impressionTrackingLabel="impressionTrackingLabel"
		:impressionTrackingProperty="impressionTrackingProperty"
	>
		<slot />

		<template #sponsoredRecommendation>
			<slot name="sponsoredRecommendation" />
		</template>
	</HeadlinedTitleList>
</template>

<script setup lang="ts">
import HeadlinedTitleList from '@/components/HeadlinedTitleList.vue';

import { useSimilarTitles } from '@/helpers/composables/useSimilarTitles';

import type { TitleFilter } from '@/@types/graphql-types';
import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { TitleDetailSeason, TitleDetail } from '@/interfaces/title-details-graphql';
import type { SponsoredAdFragment } from '@/features/sponsored-recommendations/graphql/fragments/SponsoredAd.fragment';

interface SimilarTitlesProps {
	title: NonNullable<TitleDetail | TitleDetailSeason['show']>;
	isUpcoming?: boolean;
	filters?: TitleFilter;
	minTitles?: number;
	sponsoredAd?: SponsoredAdFragment | undefined;
	additionalContexts?: SnowplowContext[];
	impressionTrackingLabel?: string;
	impressionTrackingProperty?: string; // @todo problems with enum types - ImpressionTrackingEvents | '';
}

const props = withDefaults(defineProps<SimilarTitlesProps>(), {
	sponsoredAd: undefined,
	isUpcoming: false,
	minTitles: 1,
	filters: () => ({}),
	additionalContexts: () => [],
	impressionTrackingLabel: '',
	impressionTrackingProperty: '',
});

const { similarTitles, isEmpty } = useSimilarTitles({
	titleId: () => props.title.id,
	isUpcoming: () => props.isUpcoming,
	filters: () => props.filters,
	minTitles: () => props.minTitles,
});
</script>
